import ApplicationController from "./application_controller.js"

export default class extends ApplicationController {
  static targets = [ "" ]

  connect() {
    this.questions = JSON.parse(this.data.get('questions'))
    this.showQuestion(this.questions[0], true)
  }

  questionElement(q) {
    return this.element.querySelector(`*[data-eligibility-question='${q.name}'`)
  }

  showQuestion(q, show) {
    this.show(this.questionElement(q), show)
  }

  questionAnswered(ev) {
    let i = this.questions.findIndex(q => q.name == ev.target.name)
    let q = this.questions[i]
    if (q.pass) {
      // Pass / fail question

      if (ev.target.value == q.pass) {
        // Pass this question
        this.showFailMessage(q, false)
        i += 1
        let next = this.questions[i]
        if (next) {
          this.showQuestion(next, true)
        } else {
          this.showPassed(true)
        }
      } else {
        // Fail this question
        this.showFailMessage(q, true)
        for (i+=1 ; i < this.questions.length; i++) {
          this.showQuestion(this.questions[i], false)
        }
        this.showPassed(false)
      }

    } else {
      // Skip next question

      let skip = (ev.target.value == q.skip_next)
      this.showQuestion(this.questions[i+1], !skip)
      this.showQuestion(this.questions[i+2], skip)
    }
  }

  showFailMessage(q, show) {
    let el = this.questionElement(q).querySelector('.not_eligible')
    this.show(el, show)
  }

  show(el, show) {
    if (show) {
      el.classList.remove("hidden")
      el.scrollIntoViewIfNeeded()
    } else {
      el.classList.add("hidden")
    }
  }

  showPassed(show) {
    this.show(this.element.querySelector(".success"), show)
  }

}
